export default [
    {
        name: 'stocktakes.mine',
        path: '/stocktakes/my-stocktakes',
        component: () => import("@/views/modules/stocktake/pages/my-stocktakes/List.vue"),
    },
    {
        name: 'stocktakes.stocktake.lines',
        path: '/stocktakes/:id/lines',
        component: () => import("@/views/modules/stocktake/pages/stocktake-lines/List.vue"),
    },
    {
        name: 'stocktakes.all',
        path: '/stocktakes',
        component: () => import("@/views/modules/stocktake/pages/all-stocktakes/List.vue"),
    }
]
